import { render, staticRenderFns } from "./FormComplemento.vue?vue&type=template&id=cb59bff6&scoped=true&"
import script from "./FormComplemento.vue?vue&type=script&lang=js&"
export * from "./FormComplemento.vue?vue&type=script&lang=js&"
import style0 from "./FormComplemento.vue?vue&type=style&index=0&id=cb59bff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb59bff6",
  null
  
)

export default component.exports